import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListAllCollectionsResponse } from './list-all-collections-response';
import { listAllCollectionsResponseSchema } from './list-all-collections-response';

export async function listAllCollectionsApi(): Promise<
  IValidatedResponse<IListAllCollectionsResponse>
> {
  return getRequest<IListAllCollectionsResponse>({
    path: '/sys/collections/all',
    schema: listAllCollectionsResponseSchema,
  });
}
